export default "__VITE_ASSET__C5Nz1m3B__"